"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.addLocaleToLink = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _Text2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Separator5 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _LinkList = _interopRequireDefault(require("@kiwicom/orbit-components/lib/LinkList"));
var _Collapse = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Collapse"));
var _Drawer = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Drawer"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Modal = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Portal = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Portal"));
var _PanelTop = _interopRequireDefault(require("./PanelTop"));
var _LoggedPanelTop2 = _interopRequireDefault(require("./LoggedPanel/LoggedPanelTop"));
var _SidePanelButtonLink = _interopRequireDefault(require("./SidePanelButtonLink"));
var _SidePanelTextLink2 = _interopRequireDefault(require("./SidePanelTextLink"));
var _RegionalSettingsButton = _interopRequireDefault(require("../components/RegionalSettingsButton"));
var _Media = _interopRequireDefault(require("../components/Media"));
var _context = require("../../../services/auth/context");
var MODALS = _interopRequireWildcard(require("../../../consts/modals"));
var _context2 = require("../../../services/brand/context");
var _context3 = require("../../../services/intl/context");
var _brandedItems = require("../services/brandedItems");
var _context4 = require("../services/context");
var _events = require("../consts/events");
var _context5 = require("../../../services/log/context");
var _jsxRuntime = require("react/jsx-runtime");
var _LoggedPanelTop, _FormattedMessage, _Separator, _Separator2, _Text, _Separator3, _Separator4, _FormattedMessage2, _FormattedMessage3, _FormattedMessage4, _FormattedMessage5, _SidePanelTextLink;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * This function ensures that we add the locale only available from
 * the Intl provider to links coming from the brand config.
 * They usually fall into 2 categories:
 * - full URLs (e.g. https://media.kiwi.com)
 * - relative URLs (e.g. /pages/content/legal)
 * We want to add the locale only to relative URLs.
 */
const addLocaleToLink = (locale, link) => {
  if (link.startsWith("http")) {
    return link;
  }
  if (/^\/[a-z]{2}(-[a-z]{2})?\//i.test(link)) {
    return link;
  }
  if (link.startsWith("/")) {
    return `/${locale}${link}`;
  }
  return `/${locale}/${link}`;
};
exports.addLocaleToLink = addLocaleToLink;
const SocialLink = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "SidePanel__SocialLink",
  componentId: "sc-z6dj57-0"
})(["padding:10px 0;color:", ";cursor:pointer;&:link,&:visited{color:", ";}&:hover{color:", ";}"], ({
  theme
}) => theme.orbit.paletteInkDark, ({
  theme
}) => theme.orbit.paletteInkDark, ({
  theme
}) => theme.orbit.paletteProductNormal);
const SidePanel = ({
  hidePanel,
  isOpen,
  brandLanguage,
  modalId,
  subscriptionModalContent,
  onOpenHelp,
  debugModalContent
}) => {
  const {
    isRegionalSettingsShown,
    isHelpShown,
    isSignInShown
  } = (0, _context4.useNavConfig)();
  const {
    auth
  } = (0, _context.useAuth)();
  const brand = (0, _context2.useBrand)();
  const {
    company_name: companyName
  } = (0, _context2.useBrand)();
  const socialMedia = (0, _brandedItems.getSocialMediaItems)(brand);
  const company = (0, _brandedItems.getPagesItems)(brand);
  const intl = (0, _reactIntl.useIntl)();
  const {
    language
  } = (0, _context3.useIntl)();
  const isLoggedIn = auth != null;
  const [openedModal, setOpenedModal] = React.useState(MODALS.NONE);
  const {
    log
  } = (0, _context5.useLog)();
  const handleOpenHelp = React.useCallback(() => {
    onOpenHelp();
    hidePanel();
    log(_events.HELP_BUTTON_CLICKED, {});
  }, [onOpenHelp, hidePanel, log]);
  const handleOpenSubscription = React.useCallback(() => {
    setOpenedModal(MODALS.SUBSCRIPTION);
    hidePanel();
  }, [hidePanel]);
  const handleOpenDebug = React.useCallback(() => {
    setOpenedModal(MODALS.DEBUG);
    hidePanel();
  }, [hidePanel]);
  const handleCloseModal = React.useCallback(() => {
    setOpenedModal(MODALS.NONE);
  }, []);
  const handleOpenRegionalSettingsModal = React.useCallback(openModal => {
    openModal();
    hidePanel();
  }, [hidePanel]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Drawer.default, {
      width: "420px",
      shown: isOpen,
      onClose: hidePanel,
      dataTest: "TopNav-SideNav",
      labelHide: intl.formatMessage({
        id: "orbit.drawer_hide"
      }),
      children: [!isLoggedIn && isSignInShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PanelTop.default, {
        hidePanel: hidePanel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Media.default, {
        lessThan: "tablet",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          spacing: "XSmall",
          children: [isLoggedIn && (_LoggedPanelTop || (_LoggedPanelTop = /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoggedPanelTop2.default, {}))), isHelpShown && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
              ariaControls: intl.formatMessage({
                id: "navbar.header.help_and_support"
              }),
              onClick: handleOpenHelp,
              children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.header.help_and_support"
              }))
            }), _Separator || (_Separator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator5.default, {}))]
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
        spacing: "small",
        spaceAfter: "medium",
        children: isRegionalSettingsShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RegionalSettingsButton.default, {
          modalId: modalId,
          brandLanguage: brandLanguage,
          render: ({
            countryFlag,
            text,
            openModal
          }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelButtonLink.default, {
              ariaControls: intl.formatMessage({
                id: "navbar.regional_settings"
              }),
              iconLeft: countryFlag,
              title: intl.formatMessage({
                id: "navbar.regional_settings"
              }),
              onClick: () => handleOpenRegionalSettingsModal(openModal),
              children: text
            }), _Separator2 || (_Separator2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator5.default, {}))]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spacing: "medium",
        children: [Boolean(debugModalContent) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
            onClick: handleOpenDebug,
            children: _Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
              as: "span",
              weight: "medium",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.debug_window"
              })
            }))
          }), _Separator3 || (_Separator3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator5.default, {}))]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
          href: `/${language.id}/pages/mobile`,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
            as: "span",
            weight: "medium",
            type: "secondary",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "navbar.sidepanel.kiwi_mobile",
              values: {
                companyName
              }
            })
          })
        }), _Separator4 || (_Separator4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator5.default, {})), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
            as: "span",
            weight: "medium",
            type: "secondary",
            children: intl.formatMessage({
              id: "navbar.sidepanel.discover"
            })
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LinkList.default, {
            indent: true,
            children: [subscriptionModalContent != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              onClick: handleOpenSubscription,
              children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.discover.subscribe"
              }))
            }), company.stories && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.stories.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                ...company.stories.title,
                values: {
                  companyName
                }
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
            as: "span",
            weight: "medium",
            type: "secondary",
            children: intl.formatMessage({
              id: "navbar.sidepanel.guidelines"
            })
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LinkList.default, {
            indent: true,
            children: [company.terms && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.terms.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                ...company.terms.title
              })
            }), company.gdpr_terms && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.gdpr_terms.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                ...company.gdpr_terms.title
              })
            }), company.privacy && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.privacy.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                ...company.privacy.title
              })
            }), company.security && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.security.link),
              children: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.guidelines.security"
              }))
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: `/${language.id}/pages/content/refunds`,
              children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.guidelines.refunds"
              }))
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: `/${language.id}/pages/cookies_settings`,
              children: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.general.title"
              }))
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
            as: "span",
            weight: "medium",
            type: "secondary",
            children: intl.formatMessage({
              id: "navbar.sidepanel.company"
            })
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LinkList.default, {
            indent: true,
            children: [company.about && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: `/${language.id}/pages/content/about`,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.company.about_kiwi",
                values: {
                  companyName
                }
              })
            }), _SidePanelTextLink || (_SidePanelTextLink = /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: "https://partners.kiwi.com/",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "footer.company.partnership"
              })
            })), company.guarantee && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.guarantee.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.company.kiwi_guarantee",
                values: {
                  companyName
                }
              })
            }), company.careers && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.careers.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                ...company.careers.title
              })
            }), brand.id === "kiwicom" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: "https://code.kiwi.com/",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "navbar.sidepanel.company.code_kiwi",
                values: {
                  companyName
                }
              })
            }), company.media && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanelTextLink2.default, {
              href: addLocaleToLink(language.id, company.media.link),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                ...company.media.title
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
          justify: "center",
          children: socialMedia.map(({
            link,
            Icon,
            label
          }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(SocialLink, {
            href: link,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": label && intl.formatMessage(label),
            children: Icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
              className: "socialIcon"
            })
          }, link))
        })]
      })]
    }), openedModal === MODALS.SUBSCRIPTION && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.default, {
      renderInto: modalId,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
        onClose: handleCloseModal,
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
          children: subscriptionModalContent
        })
      })
    }), openedModal === MODALS.DEBUG && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.default, {
      renderInto: modalId,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
        onClose: handleCloseModal,
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
          children: debugModalContent
        })
      })
    })]
  });
};
var _default = SidePanel;
exports.default = _default;